import { Button, Modal } from 'antd';

type IncidenceRequestDeleteConfirmModalProps = {
  open: boolean;
  mobileOnly: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const IncidenceRequestDeleteConfirmModal = ({
  open,
  mobileOnly,
  onClose,
  onConfirm,
}: IncidenceRequestDeleteConfirmModalProps) => {
  return (
    <Modal
      open={open}
      title="Eliminar solicitud"
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      maskClosable={false}
      centered
      width={mobileOnly ? 'calc(100% - 40px)' : 510}
      className="incidence-request-delete-modal"
      getContainer={false}
      data-cy="incidence-request-delete-modal"
    >
      <p className="incidence-request-delete-modal-description">
        ¿Deseas eliminar esta solicitud de incidencia? Esta acción no se puede
        deshacer.
      </p>

      <div className="incidence-request-delete-modal-footer">
        <Button
          className="incidence-request-delete-modal-btn incidence-request-delete-modal-btn-cancel"
          onClick={onClose}
          data-cy="incidence-request-delete-cancel-btn"
        >
          Cancelar
        </Button>
        <Button
          className="incidence-request-delete-modal-btn incidence-request-delete-modal-btn-confirm"
          onClick={onConfirm}
          data-cy="incidence-request-delete-confirm-btn"
        >
          Eliminar
        </Button>
      </div>
    </Modal>
  );
};
